import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { ChevronLeft, ChevronRight } from "../../icon/icon-map";

@Component({
  selector: "phx-month-picker-header",
  templateUrl: "./phx-month-picker-header.component.html",
  styleUrls: ["./phx-month-picker-header.component.scss"],
  host: {
    class: 'phx-month-picker-header',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhxMonthPickerHeaderComponent {
  @Input() public year: number = new Date().getFullYear();
  
  @Output() public nextYear = new EventEmitter<void>();
  @Output() public previousYear = new EventEmitter<void>();

  public readonly chevronRightIcon: string = ChevronRight;
  public readonly chevronLeftIcon: string = ChevronLeft;

  public onNextYear(): void {
    this.nextYear.emit();
  }

  public onPreviousYear(): void {
    this.previousYear.emit();
  }
}
